var render = function () {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("transition-group", { attrs: { name: "slide-fade" } }, [
          _vm.isBaixaDisabled()
            ? _c(
                "a",
                {
                  key: "suspen",
                  staticClass: "btn",
                  class:
                    ((_obj = {}),
                    (_obj[_vm.colorSelected] = _vm.isFieldChecked("suspensos")),
                    (_obj[_vm.colorDeselected] =
                      !_vm.isFieldChecked("suspensos")),
                    (_obj["btn-circle"] = _vm.isButtonCircle()),
                    _obj),
                  attrs: { href: "javascript:;" },
                  on: {
                    click: function ($event) {
                      return _vm.filterSelected("suspensos")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-clock-o" }),
                  _vm._v(" Suspenso\n            "),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row margin-top-15" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.isClientesFornecedoresOrCliente()
          ? _c(
              "a",
              {
                staticClass: "btn",
                class:
                  ((_obj$1 = {}),
                  (_obj$1[_vm.colorSelected] =
                    _vm.isFieldChecked("previsoesCre")),
                  (_obj$1[_vm.colorDeselected] =
                    !_vm.isFieldChecked("previsoesCre")),
                  (_obj$1["btn-circle"] = _vm.isButtonCircle()),
                  _obj$1),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected("previsoesCre")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-dollar" }),
                _vm._v(" Previsão CRE\n            "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isClientesFornecedoresOrFornecedor()
          ? _c(
              "a",
              {
                staticClass: "btn",
                class:
                  ((_obj$2 = {}),
                  (_obj$2[_vm.colorSelected] =
                    _vm.isFieldChecked("previsoesCpa")),
                  (_obj$2[_vm.colorDeselected] =
                    !_vm.isFieldChecked("previsoesCpa")),
                  (_obj$2["btn-circle"] = _vm.isButtonCircle()),
                  _obj$2),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected("previsoesCpa")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-dollar" }),
                _vm._v(" Previsão CPA\n            "),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }